import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls"
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme,
  Checkbox,
  FormControlLabel,
  Tooltip
} from "@material-ui/core"
import { useHistory, useParams } from "react-router-dom"
import { deleteClient, getClientById, postClient, updateClient } from "../../../../api/client"
import { useSkeleton } from "../../../hooks/useSkeleton"
import PreviewDialog from "../../../components/dialogs/PreviewDialog"
import { SERVER_URL } from "../../../../api"
import { alertError, alertSuccess } from "../../../../utils/logger"
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog"
import { buttonsStyle } from '../../../components/tables/table'
import { Visibility } from '@material-ui/icons'

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: '#F64E60'
    }
  }
})

function getEmptyClient() {
  return {
    name: '',
    logoURL: '',
    active: true,
    order: null
  }
}


export default function EditClientsPage() {
  const [client, setClient] = useState(getEmptyClient())
  const [selectedImage, setSelectedImage] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [openPreviewImage, setOpenPreviewImage] = useState(false)
  const clientId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (!clientId) {
      disableLoadingData()
      return
    }
    getClientById(clientId).then(res => {
      if (res.status === 200) {
        setClient(res.data)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get client.' })
      history.push('/clients')
    })
  }, [clientId, disableLoadingData, history])

  function saveClient() {
    if (!clientId) {
      postClient(client, selectedImage).then(res => {
        if (res.status === 201) {
          alertSuccess({ title: 'Saved!', customMessage: 'Client successfully created.' })
          history.push('/clients')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save client.' })
      })
    } else {
      updateClient(clientId, client, selectedImage).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
          history.push('/clients')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save changes.' })
      })
    }
  }

  const handleChange = (element) => (event) => {
    setClient({ ...client, [element]: event.target.value })
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Edit client'>
        </CardHeader>
        <CardBody>
          <TextField
            id={`name`}
            label="Name"
            value={client.name || ''}
            onChange={handleChange('name')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
          {client._id && <TextField
            id={`order`}
            label="Order"
            value={client.order || ''}
            onChange={handleChange('order')}
            InputLabelProps={{
              shrink: true
            }}
            type="number"
            margin="normal"
            variant="outlined"
            required
            disabled
          />}
          <label className='mt-4' htmlFor={"upload-logo"}>
            <input
              style={{ display: 'none' }}
              id={"upload-logo"}
              name={"upload-logo"}
              type="file"
              accept={'image/*'}
              onChange={(e) => {
                setSelectedImage(e.target.files[0])
              }}
            />
            <Button
              style={{ marginRight: '15px' }}
              color="secondary"
              component="span"
              variant="outlined">
              {((selectedImage || client.logoURL !== '') ? 'Change logo' : 'Upload logo')}
            </Button>
          </label>
          {(selectedImage || client.logoURL !== '') &&
            <>
              <Tooltip title={'Preview logo'}>
                <Button
                  size="small"
                  onClick={() => setOpenPreviewImage(true)}
                  style={buttonsStyle}>
                  <Visibility/>
                </Button>
              </Tooltip>
              <PreviewDialog
                title={'Preview logo'}
                open={openPreviewImage}
                setOpen={setOpenPreviewImage}
                src={(selectedImage) ? URL.createObjectURL(selectedImage) : `${SERVER_URL}/${client.logoURL}`}
              />
              <span style={{ marginLeft: '15px' }}>
                {selectedImage ? selectedImage?.name : (client.logoURL !== '' ? client.logoURL.split(/-(.*)/s)[1] : '')}
              </span>
            </>
					}          
          <br />
          <br />
          <FormControlLabel
            control={<Checkbox checked={client.active} onChange={() => setClient({ ...client, active: !client.active })} name="checkActive" />}
            label="Active"
          />
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/clients')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Back
      </Button>
      <Button
        onClick={() => saveClient()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Save client
      </Button>
      {clientId && <>
        <MuiThemeProvider theme={theme}>
          <Button
            onClick={() => setOpenConfirmDialog(true)}
            variant="outlined"
            color="secondary">
            Delete client
          </Button>
        </MuiThemeProvider>

        <ConfirmDialog
          title={'Are you sure you want to delete this client?'}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteClient(clientId).then(res => {
              if (res.status === 204 || res.status === 200) {
                alertSuccess({ title: 'Deleted!', customMessage: 'Client deleted successfully' })
                history.push('/clients')
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'Could not delete client.' })
            })
          }}
        />
      </>}
    </>
  );
}
